// src/components/index/MagicParticles.js
import { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFireflyPreset } from "@tsparticles/preset-firefly";

export default function MagicParticles() {
  const [init, setInit] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Solo activarlo en pantallas grandes
    if (window.innerWidth > 1024) {
      setShouldRender(true);
      initParticlesEngine(async (engine) => {
        await loadFireflyPreset(engine);
        setInit(true);
      });
    }
  }, []);

  if (!init || !shouldRender) return null;

  return (
    <Particles
      id="tsparticles"
      options={{
        fullScreen: false,
        preset: "firefly",
        background: { color: "transparent" },
        interactivity: {
          events: {
            onClick: { enable: false },
            onHover: { enable: false },
            resize: true,
          },
        },
        particles: {
          number: {
            value: 100,
            density: {
              enable: true,
              area: 800,
            },
          },
          color: {
            value: ["#c3ab49", "#fef3c7"],
          },
          size: {
            value: { min: 0.5, max: 3 },
          },
          move: {
            enable: true,
            speed: 0.3,
            direction: "none",
            random: true,
            straight: false,
            outModes: { default: "out" },
          },
          opacity: {
            value: { min: 0.1, max: 0.8 },
            animation: {
              enable: true,
              speed: 0.5,
              minimumValue: 0.1,
              sync: false,
            },
          },
        },
      }}
      className="w-full h-full"
    />
  );
}
